query TranslationShow($id: ID!) {
  translation(id: $id) {
    id
    project
    namespace
    version
    variants {
      languageCode
      translated
      untranslated
      total
    }
    createdAt
    updatedAt
    deletedAt
    deleted
  }
}
